<div class="flex flex-wrap justify-end gap-4 filters-wrapper">
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="searchBySecurityType"
    type="text"
    placeholder="Search by security type"
    class="border-b text-sm border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'searchBySecurityType')"
  />
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="searchByName"
    type="text"
    placeholder="Search by issuer name"
    class="border-b text-sm border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'searchByName')"
  />
</div>

<div class="mb-4"></div>
<div>
  <p-table
    [value]="unReferenceSecurity"
    [paginator]="unReferenceSecurity.length > 0"
    [first]="first"
    (onLazyLoad)="loadData($event)"
    [lazy]="true"
    [totalRecords]="paginator.totalCount"
    [rows]="paginator.pageSize"
    [loading]="isLoading"
    [showCurrentPageReport]="true"
    dataKey="arcId"
    [tableStyle]="{ 'min-width': '50rem' }"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    (onPage)="onIssuerPageChange($event)"
    [(selection)]="selectedUnReferenceSecurity"
    [rowsPerPageOptions]="[10, 25, 50]"
  >
    <ng-template #header>
      <tr>
        <th>A R C. Id</th>
        <th>Security Type</th>
        <th>Issuer Name</th>

        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template #body let-product>
      <tr>
        <td>
          {{ product.asReportedSecurityId || "N/A" }}
        </td>
        <td
          style="
            max-width: 300px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          "
        >
          <span
            [pTooltip]="product.asReportedSecurityType"
            tooltipPosition="top"
            [tooltipStyleClass]="'custom-tooltip'"
            [autoHide]="false"
            [tooltipDisabled]="!product.asReportedSecurityType"
            class="block overflow-hidden text-ellipsis whitespace-nowrap"
          >
            {{ product.asReportedSecurityType || "N/A" }}
          </span>
        </td>
        <!-- <td>{{ product.asReportedSecurityType || "N/A" }}</td> -->
        <td>{{ product.asReportedIssuerName || "N/A" }}</td>

        <td>
          <button
            class="text-red-600 hover:text-red-400 px-3 py-1 rounded flex items-center gap-2 cursor-pointer"
            (click)="onDeleteClick(product)"
          >
            <i class="pi pi-trash"></i>
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-template #noData>
  <div class="text-center py-6 text-gray-500">No record found.</div>
</ng-template>
<p-confirmDialog></p-confirmDialog>
